import React from "react";

/** @deprecated */
const DeprecatedLink = ({
  children,
  className = "",
  type = "primary",
  ...other
}) => {
  const linkTypes = {
    primary: "purple",
    info: "blue",
    success: "green",
    warning: "orange",
    danger: "red",
    neutral: "gray",
  };

  const typeColor = linkTypes[type];

  const classes = `text-${typeColor}-500 hover:text-${typeColor}-600 mr-4`;

  return (
    <a className={`${className} ${classes}`} {...other}>
      {children}
    </a>
  );
};

export default DeprecatedLink;
